import { t } from 'src/translations'

/**
 * Returns the appropriate subtitle translation key and params for a modifier group
 * based on its min/max selection constraints.
 */
export const getModifierGroupSubtitle = (
  minSelections?: number | null,
  maxSelections?: number | null
): string => {
  if (maxSelections && minSelections === maxSelections) {
    return t('selection-list.select-exactly', { maxSelections })
  }
  if (minSelections && maxSelections) {
    return t('selection-list.select-min-max', {
      minSelections,
      maxSelections
    })
  }
  if (maxSelections) {
    return t('selection-list.select-max-up-to', { maxSelections })
  }
  if (minSelections && minSelections > 0) {
    return t('selection-list.select-at-least', { minSelections })
  }
  return t('selection-list.optional')
}
